// source: netop_rc_transport.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var netop_rc_tracing_pb = require('./netop_rc_tracing_pb.js');
goog.object.extend(proto, netop_rc_tracing_pb);
goog.exportSymbol('proto.netop.rc.transport.Ack', null, global);
goog.exportSymbol('proto.netop.rc.transport.Disconnect', null, global);
goog.exportSymbol('proto.netop.rc.transport.Message', null, global);
goog.exportSymbol('proto.netop.rc.transport.Meta', null, global);
goog.exportSymbol('proto.netop.rc.transport.Nack', null, global);
goog.exportSymbol('proto.netop.rc.transport.Retriable', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.transport.Meta = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.netop.rc.transport.Meta.repeatedFields_, null);
};
goog.inherits(proto.netop.rc.transport.Meta, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.transport.Meta.displayName = 'proto.netop.rc.transport.Meta';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.transport.Message = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.transport.Message, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.transport.Message.displayName = 'proto.netop.rc.transport.Message';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.transport.Ack = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.transport.Ack, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.transport.Ack.displayName = 'proto.netop.rc.transport.Ack';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.transport.Nack = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.transport.Nack, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.transport.Nack.displayName = 'proto.netop.rc.transport.Nack';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.transport.Disconnect = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.transport.Disconnect, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.transport.Disconnect.displayName = 'proto.netop.rc.transport.Disconnect';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.netop.rc.transport.Meta.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.transport.Meta.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.transport.Meta.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.transport.Meta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.transport.Meta.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    replyId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    timestamp: jspb.Message.getFieldWithDefault(msg, 3, 0),
    traceList: jspb.Message.toObjectList(msg.getTraceList(),
    netop_rc_tracing_pb.TraceMessage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.transport.Meta}
 */
proto.netop.rc.transport.Meta.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.transport.Meta;
  return proto.netop.rc.transport.Meta.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.transport.Meta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.transport.Meta}
 */
proto.netop.rc.transport.Meta.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReplyId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTimestamp(value);
      break;
    case 4:
      var value = new netop_rc_tracing_pb.TraceMessage;
      reader.readMessage(value,netop_rc_tracing_pb.TraceMessage.deserializeBinaryFromReader);
      msg.addTrace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.transport.Meta.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.transport.Meta.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.transport.Meta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.transport.Meta.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReplyId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getTraceList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      netop_rc_tracing_pb.TraceMessage.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.netop.rc.transport.Meta.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.transport.Meta} returns this
 */
proto.netop.rc.transport.Meta.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reply_id = 2;
 * @return {string}
 */
proto.netop.rc.transport.Meta.prototype.getReplyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.transport.Meta} returns this
 */
proto.netop.rc.transport.Meta.prototype.setReplyId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 timestamp = 3;
 * @return {number}
 */
proto.netop.rc.transport.Meta.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.transport.Meta} returns this
 */
proto.netop.rc.transport.Meta.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated netop.rc.tracing.TraceMessage trace = 4;
 * @return {!Array<!proto.netop.rc.tracing.TraceMessage>}
 */
proto.netop.rc.transport.Meta.prototype.getTraceList = function() {
  return /** @type{!Array<!proto.netop.rc.tracing.TraceMessage>} */ (
    jspb.Message.getRepeatedWrapperField(this, netop_rc_tracing_pb.TraceMessage, 4));
};


/**
 * @param {!Array<!proto.netop.rc.tracing.TraceMessage>} value
 * @return {!proto.netop.rc.transport.Meta} returns this
*/
proto.netop.rc.transport.Meta.prototype.setTraceList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.netop.rc.tracing.TraceMessage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.netop.rc.tracing.TraceMessage}
 */
proto.netop.rc.transport.Meta.prototype.addTrace = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.netop.rc.tracing.TraceMessage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.netop.rc.transport.Meta} returns this
 */
proto.netop.rc.transport.Meta.prototype.clearTraceList = function() {
  return this.setTraceList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.transport.Message.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.transport.Message.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.transport.Message} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.transport.Message.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.transport.Meta.toObject(includeInstance, f),
    body: msg.getBody_asB64(),
    expectedResponse: msg.getExpectedResponse_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.transport.Message}
 */
proto.netop.rc.transport.Message.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.transport.Message;
  return proto.netop.rc.transport.Message.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.transport.Message} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.transport.Message}
 */
proto.netop.rc.transport.Message.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.transport.Meta;
      reader.readMessage(value,proto.netop.rc.transport.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setBody(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setExpectedResponse(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.transport.Message.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.transport.Message.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.transport.Message} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.transport.Message.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.transport.Meta.serializeBinaryToWriter
    );
  }
  f = message.getBody_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      3,
      f
    );
  }
  f = message.getExpectedResponse_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.transport.Message.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.transport.Message} returns this
 */
proto.netop.rc.transport.Message.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.transport.Meta}
 */
proto.netop.rc.transport.Message.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.transport.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.transport.Meta, 2));
};


/**
 * @param {?proto.netop.rc.transport.Meta|undefined} value
 * @return {!proto.netop.rc.transport.Message} returns this
*/
proto.netop.rc.transport.Message.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.transport.Message} returns this
 */
proto.netop.rc.transport.Message.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.transport.Message.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bytes body = 3;
 * @return {!(string|Uint8Array)}
 */
proto.netop.rc.transport.Message.prototype.getBody = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes body = 3;
 * This is a type-conversion wrapper around `getBody()`
 * @return {string}
 */
proto.netop.rc.transport.Message.prototype.getBody_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getBody()));
};


/**
 * optional bytes body = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBody()`
 * @return {!Uint8Array}
 */
proto.netop.rc.transport.Message.prototype.getBody_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getBody()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.netop.rc.transport.Message} returns this
 */
proto.netop.rc.transport.Message.prototype.setBody = function(value) {
  return jspb.Message.setProto3BytesField(this, 3, value);
};


/**
 * optional bytes expected_response = 4;
 * @return {!(string|Uint8Array)}
 */
proto.netop.rc.transport.Message.prototype.getExpectedResponse = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes expected_response = 4;
 * This is a type-conversion wrapper around `getExpectedResponse()`
 * @return {string}
 */
proto.netop.rc.transport.Message.prototype.getExpectedResponse_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getExpectedResponse()));
};


/**
 * optional bytes expected_response = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getExpectedResponse()`
 * @return {!Uint8Array}
 */
proto.netop.rc.transport.Message.prototype.getExpectedResponse_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getExpectedResponse()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.netop.rc.transport.Message} returns this
 */
proto.netop.rc.transport.Message.prototype.setExpectedResponse = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.transport.Ack.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.transport.Ack.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.transport.Ack} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.transport.Ack.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.transport.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.transport.Ack}
 */
proto.netop.rc.transport.Ack.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.transport.Ack;
  return proto.netop.rc.transport.Ack.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.transport.Ack} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.transport.Ack}
 */
proto.netop.rc.transport.Ack.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.transport.Meta;
      reader.readMessage(value,proto.netop.rc.transport.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.transport.Ack.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.transport.Ack.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.transport.Ack} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.transport.Ack.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.transport.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.transport.Ack.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.transport.Ack} returns this
 */
proto.netop.rc.transport.Ack.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.transport.Meta}
 */
proto.netop.rc.transport.Ack.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.transport.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.transport.Meta, 2));
};


/**
 * @param {?proto.netop.rc.transport.Meta|undefined} value
 * @return {!proto.netop.rc.transport.Ack} returns this
*/
proto.netop.rc.transport.Ack.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.transport.Ack} returns this
 */
proto.netop.rc.transport.Ack.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.transport.Ack.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.transport.Nack.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.transport.Nack.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.transport.Nack} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.transport.Nack.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.transport.Meta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.transport.Nack}
 */
proto.netop.rc.transport.Nack.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.transport.Nack;
  return proto.netop.rc.transport.Nack.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.transport.Nack} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.transport.Nack}
 */
proto.netop.rc.transport.Nack.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.transport.Meta;
      reader.readMessage(value,proto.netop.rc.transport.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.transport.Nack.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.transport.Nack.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.transport.Nack} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.transport.Nack.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.transport.Meta.serializeBinaryToWriter
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.transport.Nack.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.transport.Nack} returns this
 */
proto.netop.rc.transport.Nack.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.transport.Meta}
 */
proto.netop.rc.transport.Nack.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.transport.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.transport.Meta, 2));
};


/**
 * @param {?proto.netop.rc.transport.Meta|undefined} value
 * @return {!proto.netop.rc.transport.Nack} returns this
*/
proto.netop.rc.transport.Nack.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.transport.Nack} returns this
 */
proto.netop.rc.transport.Nack.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.transport.Nack.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.transport.Disconnect.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.transport.Disconnect.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.transport.Disconnect} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.transport.Disconnect.toObject = function(includeInstance, msg) {
  var f, obj = {
    netopMessageType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    meta: (f = msg.getMeta()) && proto.netop.rc.transport.Meta.toObject(includeInstance, f),
    reason: jspb.Message.getFieldWithDefault(msg, 3, 0),
    retryAfter: jspb.Message.getFieldWithDefault(msg, 4, 0),
    retriable: jspb.Message.getFieldWithDefault(msg, 5, 0),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    message: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.transport.Disconnect}
 */
proto.netop.rc.transport.Disconnect.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.transport.Disconnect;
  return proto.netop.rc.transport.Disconnect.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.transport.Disconnect} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.transport.Disconnect}
 */
proto.netop.rc.transport.Disconnect.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNetopMessageType(value);
      break;
    case 2:
      var value = new proto.netop.rc.transport.Meta;
      reader.readMessage(value,proto.netop.rc.transport.Meta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setReason(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRetryAfter(value);
      break;
    case 5:
      var value = /** @type {!proto.netop.rc.transport.Retriable} */ (reader.readEnum());
      msg.setRetriable(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.transport.Disconnect.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.transport.Disconnect.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.transport.Disconnect} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.transport.Disconnect.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNetopMessageType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.netop.rc.transport.Meta.serializeBinaryToWriter
    );
  }
  f = message.getReason();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getRetryAfter();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getRetriable();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string netop_message_type = 1;
 * @return {string}
 */
proto.netop.rc.transport.Disconnect.prototype.getNetopMessageType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.transport.Disconnect} returns this
 */
proto.netop.rc.transport.Disconnect.prototype.setNetopMessageType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Meta meta = 2;
 * @return {?proto.netop.rc.transport.Meta}
 */
proto.netop.rc.transport.Disconnect.prototype.getMeta = function() {
  return /** @type{?proto.netop.rc.transport.Meta} */ (
    jspb.Message.getWrapperField(this, proto.netop.rc.transport.Meta, 2));
};


/**
 * @param {?proto.netop.rc.transport.Meta|undefined} value
 * @return {!proto.netop.rc.transport.Disconnect} returns this
*/
proto.netop.rc.transport.Disconnect.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.netop.rc.transport.Disconnect} returns this
 */
proto.netop.rc.transport.Disconnect.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.netop.rc.transport.Disconnect.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional uint32 reason = 3;
 * @return {number}
 */
proto.netop.rc.transport.Disconnect.prototype.getReason = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.transport.Disconnect} returns this
 */
proto.netop.rc.transport.Disconnect.prototype.setReason = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 retry_after = 4;
 * @return {number}
 */
proto.netop.rc.transport.Disconnect.prototype.getRetryAfter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.transport.Disconnect} returns this
 */
proto.netop.rc.transport.Disconnect.prototype.setRetryAfter = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional Retriable retriable = 5;
 * @return {!proto.netop.rc.transport.Retriable}
 */
proto.netop.rc.transport.Disconnect.prototype.getRetriable = function() {
  return /** @type {!proto.netop.rc.transport.Retriable} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.netop.rc.transport.Retriable} value
 * @return {!proto.netop.rc.transport.Disconnect} returns this
 */
proto.netop.rc.transport.Disconnect.prototype.setRetriable = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.netop.rc.transport.Disconnect.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.transport.Disconnect} returns this
 */
proto.netop.rc.transport.Disconnect.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string message = 7;
 * @return {string}
 */
proto.netop.rc.transport.Disconnect.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.netop.rc.transport.Disconnect} returns this
 */
proto.netop.rc.transport.Disconnect.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * @enum {number}
 */
proto.netop.rc.transport.Retriable = {
  ENABLED: 0,
  DISABLED: 1
};

goog.object.extend(exports, proto.netop.rc.transport);
